<li class="dropdown nav-item" *ngIf="isAppPreview">
  <a
    role="button"
    href="javascript:void(0);"
    class="dropdown nav-link"
    (click)="handleDialog()"
    matTooltip="{{ 'MODULE.DATA_APPLICATIONS.TOP_BAR.SETTING_LABEL' | translate }}"
    #toggleButton2
  >
    <svg
      *ngIf="(legend !== 'default' || label !== 'default')"
      [attr.width]="18"
      [attr.height]="18"
      viewBox="0 0 64 64"
      xmlns="http://www.w3.org/2000/svg"
      [style.color]="'white'"
    >
      <!-- Top line -->
      <line x1="24" y1="16" x2="54" y2="16" stroke="currentColor" stroke-width="4" stroke-linecap="round" />
      <circle cx="16" cy="16" r="8" fill="currentColor" />

      <!-- Bottom line -->
      <line x1="10" y1="48" x2="40" y2="48" stroke="currentColor" stroke-width="4" stroke-linecap="round" />
      <circle cx="46" cy="48" r="10" [attr.class]="'status-circle'" />
      
      <polyline points="42,48 45,51 50,44" fill="none" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>

    <svg
      *ngIf="(legend === 'default' && label === 'default')"
      [attr.width]="18"
      [attr.height]="18"
      viewBox="0 0 64 64"
      xmlns="http://www.w3.org/2000/svg"
      [style.color]="'black'"
    >
      <!-- Top line -->
      <line x1="24" y1="16" x2="54" y2="16" stroke="currentColor" stroke-width="4" stroke-linecap="round" />
      <circle cx="16" cy="16" r="8" fill="currentColor" />

      <!-- Bottom line -->
      <line x1="10" y1="48" x2="40" y2="48" stroke="currentColor" stroke-width="4" stroke-linecap="round" />
      <circle cx="48" cy="48" r="8" fill="currentColor" />
    </svg>
  </a>
</li>
